
<template>
    <div id="agThrottling">
        <div class="agInputGroup agInputGroupCentered">
          <div class="agInputGroup agInputGroupInline">
            <label>Time between records:</label>
            <b-input 
              class="agSmallInput"
              v-model="queue.config.waitTime" 
              type="number" 
              min="0" 
              step="1"
              autocomplete="false" 
              :disabled="disableUI">
            </b-input>
            <label>ms</label>
          </div>
        </div>
    </div>
</template>






<script>

// components


// modules


export default {
    name: "ag-queue-throttling",
    components: {

    },
    props:{
        disableUI: Boolean,
        workflow: Object,
        queue: Object
    },
    data(){
        return {
        };
    },
    computed: {

    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      this.reset();

    },

    methods: {

        // UI Events

        

        // emitted Events


        // other

        reset() {
          // init config object if it's empty
          if (Object.keys(this.queue.config).length == 0) {
              this.queue.config = {
                  waitTime: 0
              };
          }
        },

        prepareForSave() {
        },
    }
}

</script>






<style scoped lang="css">

</style>



// WEBPACK FOOTER //
// src/components/nodes/queues/Throttling.vue